import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import '@/registerServiceWorker';
import DOMPurify from 'dompurify';
import '@/support/Filters';
import { Plugin } from 'vue2-storage';
import VueIntersect from 'vue-intersect-directive'

Vue.use(Plugin, {
  prefix: 'maison_storage_',
  driver: 'local',
  ttl: 24 * 60 * 60  * 1000, // 24 hours
  replacer: (key: any, value: any) => value
});

Vue.config.productionTip = false;

if ((module as any).hot !== undefined) {
  require('@/setup/hot-reload');
}

DOMPurify.addHook('afterSanitizeAttributes', (node: Node) => {
  if('target' in node) {
    (node as HTMLElement).setAttribute('target','_blank');
    // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
    (node as HTMLElement).setAttribute('rel', 'noopener noreferrer');
  }
});

require('@/setup/components');
require('@/setup/plugins');

Vue.use(VueIntersect)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
